import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdHocReportType } from '@ptg-processing/features/report/constants';
import { BaseComponent } from '@ptg-shared/components';
import { Breadcrumb } from '@ptg-shared/types/models/breadcrumb.model';
import { DOCUMENT_TEMPLATE } from 'src/app/admin/features/template/constants';
import { Option } from '@ptg-shared/controls/select/select.component';
import { ChipInputType } from '@ptg-shared/controls/chip-selection/types/enums';
import { ChipSelectionComponent } from '@ptg-shared/controls/chip-selection';
import { CardFilter, ControlLabel, ExtraData, ReportFilterType } from '@ptg-processing/types/models/card-filter.model';
import { getCardListSelector, getDefaultFilterSelector, getCardConfigurationSelector, getTemplateSelector, createReportTemplateSelector, updateReportTemplateSelector, getTemplatesSelector, getDefaultTemplateSelector, generateAdhocReportSelector } from '@ptg-member/store/selectors/adhoc-report.selector';
import { filter, take, takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { AdhocReportState } from '@ptg-member/store/reducers/adhoc-report.reducer';
import { getCardListAction, getDefaultFilterAction, getCardConfigurationAction, updateReportTemplateAction, createReportTemplateAction, getTemplateAction, clearCreateReportTemplateStateAction, clearTemplateStateAction, clearCardConfigurationStateAction, clearDefaultFilterStateAction, clearUpdateReportTemplateStateAction, getTemplatesAction, getDefaultTemplateAction, clearDefaultTemplateStateAction, clearGenerateAdhocReportStateAction, generateAdhocReportAction } from '@ptg-member/store/actions/adhoc-report.actions';
import { CardProperty } from '@ptg-processing/types/models/card-property.model';
import { ENTITY_MEMBER_GUID, ENTITY_ORGANIZATION_GUID, ENTITY_PARTICIPANT_GUID, ENTITY_PERSON_GUID, GUID_EMPTY, SORT_TYPE, STATE } from '@ptg-shared/constance';
import { EntityPropertyDisplayConfiguration } from '@ptg-entity-management/services/models';
import { ACTION_COLUMN, Align, Column, getValidatorsFromColumns, GridComponent, ReorderInfo, Row } from '@ptg-shared/controls/grid';
import { VERTICAL_LINE_SEPARATOR } from '@ptg-shared/constance/common.const';
import { RadioOption } from '@ptg-shared/controls/radio-button/radio-button.component';
import { ReportTemplate, ReportTemplateColumn } from '@ptg-processing/types/models/report-template.model';
import * as fromMember from '@ptg-member/store/reducers';
import { LayoutService } from '@ptg-shared/services/layout.service';
import { deepClone, showBanner } from '@ptg-shared/utils/common.util';
import { ColumnSetPropertyDisplayConfiguration } from '@ptg-member/types/models';
import { SCREEN_ID } from '@ptg-member/constance/lookupTable.const';
import { MemberListActions } from '@ptg-member/store/actions';
import { LayoutActions } from '@ptg-shared/layout/actions';
import { ConfirmPopupComponent } from '@ptg-shared/controls/confirm-popup/confirm-popup.component';
import { ConfirmType } from '@ptg-shared/constance/confirm-type.const';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { BannerType } from '@ptg-shared/controls/banner/types/banner.model';
import { DatePipe } from '@angular/common';
import { ChipData } from '@ptg-shared/controls/view-current-filter/view-current-filter.component';
import { RelationshipOptions } from '@ptg-entity-management/types/enums';
import { AgentPropertyKey, FixedPropertyKey } from '@ptg-entity-management/constants';

@Component({
  selector: 'ptg-adhoc-report-designer',
  templateUrl: './adhoc-report-designer.component.html',
  styleUrls: ['./adhoc-report-designer.component.scss']
})
export class AdhocReportDesignerComponent extends BaseComponent implements OnInit, OnDestroy {
  listBreadcrumbs: Breadcrumb[] = [
    {
      name: DOCUMENT_TEMPLATE.ADHOC_REPORT,
      url: '/member/adhoc-report',
    },
    {
      name: 'Design Report'
    }
  ];

  errorWhileSaving: string = 'Error occurred while saving. Please try again.'

  @ViewChild('sortPropertyTable')
  gridview!: GridComponent<ColumnSetPropertyDisplayConfiguration>;
  @ViewChild('sortRowTable')
  gridviewRow!: GridComponent<ColumnSetPropertyDisplayConfiguration>;

  @ViewChild(ChipSelectionComponent) chipSelecionComponent!: ChipSelectionComponent;

  dynamicFormGroup!: FormGroup;

  fixedFormGroup!: FormGroup;

  readonly ACTION_COLUMN = ACTION_COLUMN;
  readonly ChipInputType = ChipInputType;

  componentType = {
    dropdown: 'dropdown',
    datepicker: 'datePicker'
  }

  ACTION = {
    ADD_SORT_ROW: 'addSortRow',
    EDIT_COLUMN_NAME: 'editColumnName',
    REMOVE_PROPERTY_ROW: 'removePropertyRow',
    REMOVE_SORT_ROW: 'removeSortRow',
    SORT_CHANGE: 'sortChange',
  };

  orderColumns: Column[] = [
    {
      name: 'columnName',
      editable: true,
      truncate: true,
      validators: {
        required: {
          type: (obj: any) => Validators.required,
          message: (error: any, fieldName: string) =>
            `${fieldName} is required.`,
        },
        maxlength: {
          type: (obj: any) => Validators.maxLength(this.columnNameMaxLength),
          message: (error: any, fieldName: string) =>
            `Exceed the ${error.requiredLength} character limit.`,
        },
        existed: {
          type: (obj: any) => this.checkExits(obj),
          message: (error: any, fieldName: string) =>
            `${fieldName} already exists.`,
        },
      },
      controlArgs: {
        placeholder: 'Column Name'
      },
    },
    {
      name: ACTION_COLUMN,
      align: Align.Right,
      width: '50px',
    },
  ];

  sortColumns: Column[] = [
    {
      name: 'columnName',
      truncate: true,
    },
    {
      name: ACTION_COLUMN,
      align: Align.Right,
      width: '50px',
    },
  ];

  templateNamePlaceHolder: string = 'Template Name'

  columnNameMaxLength: number = 150;

  selectedOptions: any[] = [
  ];

  canSubmit: boolean = false;

  isCompareColumn: boolean = true;

  isLoading = false;

  sortable: boolean = true;

  sortRowSection: boolean = true;

  templateId?: string;

  unsubscribe$ = new Subject<void>();

  cardName: string = '';

  bannerType: BannerType = BannerType.Hidden;

  message = '';

  isGetStoredRowData: boolean = false;

  isResetGeneralForm: boolean = false;

  listTemplates: ReportTemplate[] = [];

  personRelationShipTypes : RelationshipOptions[] = [ 
    RelationshipOptions.Spouse,
    RelationshipOptions.Child,
    RelationshipOptions.ExSpouse,
    RelationshipOptions.Parent,
    RelationshipOptions.Sibling,
    RelationshipOptions.DomesticPartner,
                ]
  // generated for

  selectedGenerateReportType: AdHocReportType = AdHocReportType.Member;
  generateReportFor: Option[] = [
    {
      value: AdHocReportType.Member,
      displayValue: 'Member',
    },
    {
      value: AdHocReportType.Payment,
      displayValue: 'Payment',
    },
  ];

  // filter dropdown options
  cardFilter: CardFilter | null = null;

  filterDropdownOptions: Option[] = [];

  filterDropdownName = "Benefit Type";

  selectedRowFilterOptions: Option[] = [];

  lstFilterDescription: string[] = [];

  oldFilterData: ExtraData[] = [];

  lstRemovedFilters: CardFilter[] = [];
  // add column box
  firstFilterValue: string | null = null;

  cardSelectionOptions: Option[] = [];

  selectedFilters: CardFilter[] = [];

  selectedCardFilters: CardFilter[] = [];

  cardFilters: CardFilter[] = [];

  storedCardFilters: CardFilter[] = [];

  defaultCardProperties: CardProperty[] = [];

  cardPropertiesWithoutFilter: CardProperty[] = [];

  cardProperties: CardProperty[] = [];

  private filterOptionsCache: Map<string, Option[]> = new Map();

  private filteredOptionsCache: Map<string, Option[]> = new Map();

  propertyOptions: RadioOption[] = [];

  availablePropertyOptions: Option[] = [];

  removedOrderColumns: EntityPropertyDisplayConfiguration[] = [];

  removedOrderRows: EntityPropertyDisplayConfiguration[] = [];

  lstStoredEntityColumns: EntityPropertyDisplayConfiguration[] = [];

  // order columns box

  // get from template api propertyDisplayConfigurations
  storedProperties: ReportTemplateColumn[] = [];

  sortPropertySectionDataTable: (EntityPropertyDisplayConfiguration & Row)[] = [];

  sortRowSectionDataTable: (EntityPropertyDisplayConfiguration & Row)[] = [];

  get templateNameCtrl(): FormControl {
    return this.fixedFormGroup?.get('templateName') as FormControl;
  }
  get reportNameCtrl(): FormControl {
    return this.fixedFormGroup?.get('reportName') as FormControl;
  }
  get generateReportForCtrl(): FormControl {
    return this.fixedFormGroup?.get('generateReportFor') as FormControl;
  }
  get filterDropdownCtrl(): FormControl {
    return this.fixedFormGroup?.get('filterDropdown') as FormControl;
  }
  get cardSelectionCtrl(): FormControl {
    return this.dynamicFormGroup?.get('cardSelection') as FormControl;
  }
  get propertyCtrl(): FormControl {
    return this.dynamicFormGroup?.get('property') as FormControl;
  }
  get columnNameCtrl(): FormControl {
    return this.dynamicFormGroup?.get('columnName') as FormControl;
  }

  constructor(
    private fb: FormBuilder,
    private store: Store<AdhocReportState>,
    private memberStore: Store<fromMember.MemberState>,
    private layoutService: LayoutService,
    public router: Router,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    private datePipe: DatePipe
  ) {
    super();
  }


  ngOnInit(): void {
    const query = {
      isIncludePropertyEntityReference: false,
      isIncludePropertyOfList: false,
      isUseFilter: false,
      screenId: SCREEN_ID.ParticipantList
    };
    super.ngOnInit();
    this.route.params.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((params) => {
      this.templateId = params.templateId;
    });

    this.initFormGroup();
    this.store.dispatch(LayoutActions.hiddenSideMenu());
    this._getListCardSelector();
    this._getDefaultFilterSelector();
    this._getCardConfigurationSelector();
    this._getParticipantPropertySelector();
    this._getDefaultTemplateSelector();
    this.store.dispatch(getCardListAction({ request: { entityId: ENTITY_MEMBER_GUID } }));
    this.memberStore.dispatch(MemberListActions.getPropertyOfParticipantsRequestRequest({ entityId: ENTITY_MEMBER_GUID, query }));
    this.getStoredReportTemplate();
  }

  initFormGroup() {
    this.fixedFormGroup = this.fb.group({
      templateName: this.fb.control(""),
      reportName: this.fb.control("", Validators.required),
      generateReportFor: this.fb.control(AdHocReportType.Member),
      filterDropdown: this.fb.control(""),
    });

    this.dynamicFormGroup = this.fb.group({
      cardSelection: this.fb.control(null),
      property: this.fb.control(""),
      columnName: this.fb.control("", Validators.required),
      systemColumnName: this.fb.control(""),
      subColumnName: this.fb.control(""),
      propertyName: this.fb.control("", Validators.required),
      type: this.fb.control(""),
      propertyNameEntityRef: this.fb.control(""),
      propertyId: this.fb.control(""),
      entityComponentId: this.fb.control(""),
      cardId: this.fb.control(""),
      entityReferencePropertyId: this.fb.control(""),
      entityReferenceLinkedId: this.fb.control(""),
      option: this.fb.control(""),
      cardName: this.fb.control(""),
    });
  }

  getDataTable(storedProperties?: ReportTemplateColumn[], loadFilter: boolean = true) {
    this.storedProperties = this.getStoredProperties();
    const properties = storedProperties || this.storedProperties;
    if(!properties.length)return;
    this.sortPropertySectionDataTable = properties.map((property) => {
      const obj = {
        ...this.getPropertyDisplayConfig({...property,
           entityReferencePropertyId: property.referencePropertyId,
           entityReferenceLinkedId: property.referenceLinkedId }),
        order: property.orderColumn,
        isUsed: property.orderRow !== null || !this.sortRowSection,
        disableDelete: property.disableDelete
      }
      return this.createInlineEditFormControls(obj);
    }).sort((a, b) => Number(a.order) - Number(b.order));
    this.lstStoredEntityColumns = [...this.sortPropertySectionDataTable];

    this.sortRowSectionDataTable = properties.reduce(
      (result, property) => {
        if (property.orderRow) {
          result.push({
            ...this.getPropertyDisplayConfig({...property,
           entityReferencePropertyId: property.referencePropertyId,
           entityReferenceLinkedId: property.referenceLinkedId }),
            order: property.orderRow,
            sortType: property.sortType,
          });
        }
        return result;
      }, [] as EntityPropertyDisplayConfiguration[]
    ).sort((a, b) => Number(a.order) - Number(b.order));

    if (!this.storedCardFilters?.length) return;
    if(loadFilter)
    this.selectedFilters = this.storedCardFilters.filter((filter) => filter.type === ReportFilterType.column).sort((a, b) => (a.configs.order ?? 0) - (b.configs.order ?? 0));

  }

  getRowFilterData() {
    const rowFilters = this.storedCardFilters.filter((filter) => filter.type === ReportFilterType.row);

    if (rowFilters.length > 0) {
      const groupedValues = rowFilters.map(filter => filter.value);
      const groupedDisplayValues = rowFilters.map(filter => filter.displayValue);
      this.oldFilterData = rowFilters.map((filter) => {
        return { id: filter.id, value: filter.value } as ExtraData;
      });
      this.cardFilter = {
        ...rowFilters[0],
        id: GUID_EMPTY,
        value: groupedValues as any,
        displayValue: groupedDisplayValues as any
      };
    }
    this.selectedRowFilterOptions = rowFilters.map((item) => {
      return {
        value: item.value || '',
        displayValue: item.displayValue || ''
      };
    })
    this.isGetStoredRowData = true;
  }

  getStoredProperties() {
    return this.storedProperties.map((config) => {
      const cloneConfig = Object.assign({}, config);
      const item = this.cardProperties.find(
        (property) => this.isExisted(config, property.propertyId)
      );
      if (item) {
        cloneConfig.propertyName = item.propertyName;
        cloneConfig.optionName = cloneConfig.option?.split('|')
          .map(
            (el: any) => item.options?.find((item) => item.key === el)?.value
          ).join(', ')
      }
      return cloneConfig;
    })
  }


  getStoredReportTemplate() {
    if (this.templateId) {
      this._getTemplateSelector();
      this.store.dispatch(getTemplateAction({ request: { templateId: this.templateId } }));
    } else {
      this.selectedGenerateReportType = AdHocReportType.Member;
      this.store.dispatch(getDefaultTemplateAction({ request: { type: this.selectedGenerateReportType } }));
    }
  }

  removeFilterCondition(removedFilter: CardFilter) {
    const removedIndex = this.cardFilters.findIndex(
      (filter) =>
        filter.cardId === removedFilter.cardId &&
        filter.propertyId === removedFilter.propertyId
    );
    if (removedIndex > -1) {
      this.cardFilters.splice(removedIndex, 1);
    }
  }

  isExisted(item: ReportTemplateColumn,
    id: string,
  ) {
    return item.propertyId === id;
  }

  _getListCardSelector() {
    this.store
      .select(getCardListSelector)
      .pipe(
        filter((res) => !!res && !res.isLoading),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((response) => {
        if (response?.payload) {
          this.cardSelectionOptions = response.payload.cards.map((item) => {
            return {
              value: item.id,
              displayValue: item.cardName,
              extraData: item.entityComponentId
            };
          });
        }
      });
  }

  _getDefaultFilterSelector() {
    this.store
      .select(getDefaultFilterSelector)
      .pipe(
        filter((res) => !!res && !res.isLoading),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((response) => {
        if (response?.payload) {
          this.cardFilter = response.payload.cardFilter;
          this.filterDropdownName = this.cardFilter.propertyName;
          this.filterDropdownOptions = this.cardFilter.valueList.map((item) => {
            return {
              value: item.key || '',
              displayValue: item.value || '',
              valueDescription: item.description || ''
            };
          });
          this.generateReportForCtrl.setValue(this.selectedGenerateReportType);
          if (!this.isGetStoredRowData) {
            this.getRowFilterData();
          }
        }
      });
  }

  _getCardConfigurationSelector() {
    this.store
      .select(getCardConfigurationSelector)
      .pipe(
        filter((res) => !!res && !res.isLoading),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((response) => {
        if (response?.error) {
          this.layoutService.showLoading = false;
        }
        if (response?.payload) {
          this.layoutService.showLoading = false;
          const { cardFilters, cardProperties } = response.payload;

          this.cardFilters = [...cardFilters];
          this.cacheFilterOptions();
          this.initializeFilterControls();
          this.cardPropertiesWithoutFilter = cardProperties;

          if (this.cardFilters.length > 0 && this.cardFilters[0].configs.required) {
            this.cardProperties = [];
          } else {
            this.firstFilterValue = null;
            this.filterCardProperties();
          }
          this.getAvailablePropertyConfigs();
          this.selectedCardFilters = cardFilters;
        }
      });
  }

  _getParticipantPropertySelector() {
    this.memberStore
      .select(fromMember.selectPropertyOfParticipants)
      .pipe(
        filter((res) => !!res && !res.isLoading),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((response: any) => {
        if (response) {
          this.cardProperties = deepClone(response?.propertyList?.propertyOfParticipants).map((item: any) => {
            const property: CardProperty = {
              propertyName: item.propertyName,
              propertyId: item.id,
              referencePropertyName: item.propertyNameEntityRef,
              referencePropertyId: item.propertyRefId,
              type: item.type,
              options: item.options,
              configs: item.configs
            }
            return property;
          });

          this.defaultCardProperties = this.cardProperties;
          this.getAvailablePropertyConfigs();
        }
      });
  }

  private _getTemplateSelector() {
    this.store
      .select(getTemplateSelector)
      .pipe(
        filter((res) => !!res && !res.isLoading),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((response) => {
        if (response?.payload) {
          const { filters, properties, type, name, reportName } = response.payload.template;
          this.storedCardFilters = [...filters];
          this.templateNameCtrl.setValue(name);
          this.reportNameCtrl.setValue(reportName);
          this.selectedGenerateReportType = type;
          this.storedProperties = [...properties];
          this.store.dispatch(getDefaultFilterAction({ request: { type: this.selectedGenerateReportType } }));
          this.getDataTable();
          this.getAvailablePropertyConfigs();
        }
      });
  }

  private _getDefaultTemplateSelector() {
    this.store
      .select(getDefaultTemplateSelector)
      .pipe(
        filter((res) => !!res && !res.isLoading),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((response) => {
        if (response?.payload) {
          const { properties } = response.payload.template;
          const propertyMappings = deepClone(properties).map((item: ReportTemplateColumn) => {
            if (item.referencePropertyId) {
              item.propertyId = item.referencePropertyId.toString();
            }
            return item;
          });
          this.store.dispatch(getDefaultFilterAction({ request: { type: this.selectedGenerateReportType } }));
          this.getDataTable(propertyMappings, false);
        }
      });
  }

  getFilterUniqueId(filter: CardFilter): string {
    return `${filter.cardId}_${filter.propertyId}`;
  }

  initializeFilterControls() {
    const datePickerControlNames: ControlLabel[] = [];
    this.cardFilters.forEach((filter, index) => {
      const controlName = `filter_${this.getFilterUniqueId(filter)}`;
      if (!this.dynamicFormGroup.contains(controlName)) {
        if (filter.configs?.required) {
          this.dynamicFormGroup.addControl(controlName, this.fb.control('', Validators.required));
        } else {
          this.dynamicFormGroup.addControl(controlName, this.fb.control(''));
        }
        if (filter.configs.componentType === this.componentType.datepicker) {
          datePickerControlNames.push({ controlName, label: filter.propertyName });
        }
      }
    });
    if (datePickerControlNames.length === 2) {
      const fromControl = this.dynamicFormGroup.get(datePickerControlNames[0].controlName);
      const toControl = this.dynamicFormGroup.get(datePickerControlNames[1].controlName);
      if (fromControl && toControl) {
        this.dynamicFormGroup.setValidators(this.dateComparisonValidator(fromControl, toControl, datePickerControlNames[0].label, datePickerControlNames[1].label));
      }
    }
  }

  dateComparisonValidator(fromControl: AbstractControl, toControl: AbstractControl, fromLabel?: string, toLabel?: string) {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      if (!fromControl || !toControl) {
        return null;
      }

      const fromDate = fromControl.value;
      const toDate = toControl.value;

      if (toControl.hasError('dateRangeInvalid')) {
        delete toControl.errors!['dateRangeInvalid'];
        if (Object.keys(toControl.errors || {}).length === 0) {
          toControl.setErrors(null);
        }
      }

      if (fromDate && toDate) {
        const from = new Date(fromDate);
        const to = new Date(toDate);

        if (to <= from) {
          const error = { dateRangeInvalid: `${toLabel} must be after ${fromLabel}.` };
          toControl.setErrors({ ...toControl.errors, ...error });
          return { dateRangeInvalid: true };
        }
      }

      return null;
    };
  }

  initializePropertyControls() {
    this.availablePropertyOptions = this.cardProperties.map(property => ({
      value: property.propertyId,
      displayValue: property.propertyName,
      extraData: `${property.cardId}_${property.componentId}`
    }));
  }

  getFilterControl(filter: CardFilter): FormControl {
    const uniqueId = this.getFilterUniqueId(filter);
    return this.dynamicFormGroup.get(`filter_${uniqueId}`) as FormControl;
  }

  getFilterOptions(filter: CardFilter): Option[] {
    const cacheKey = `${filter.cardId}_${filter.propertyId}`;

    if (this.filterOptionsCache.has(cacheKey)) {
      const cachedOptions = this.filterOptionsCache.get(cacheKey)!;
      return cachedOptions;
    }

    const options = filter.valueList ? filter.valueList.map(item => ({
      value: item.key || '',
      displayValue: item.value || '',
      valueDescription: item.description || ''
    })) : [];

    this.filterOptionsCache.set(cacheKey, options);
    return options;
  }

  getCachedFilterOptions(filter: CardFilter): Option[] {
    const cacheKey = `${filter.cardId}_${filter.propertyId}`;
    const selectedValues = this.selectedFilters
      .filter(selectedFilter =>
        selectedFilter.cardId === filter.cardId &&
        selectedFilter.propertyId === filter.propertyId
      )
      .map(selectedFilter => selectedFilter.value);

    const filteredCacheKey = `${cacheKey}_${selectedValues.join(',')}`;

    if (this.filteredOptionsCache.has(filteredCacheKey)) {
      return this.filteredOptionsCache.get(filteredCacheKey)!;
    }

    const allOptions = this.getFilterOptions(filter);
    this.filteredOptionsCache.set(filteredCacheKey, allOptions);

    return allOptions;
  }

  private cacheFilterOptions(): void {
    this.cardFilters.forEach(filter => {
      const cacheKey = `${filter.cardId}_${filter.propertyId}`;
      if (!this.filterOptionsCache.has(cacheKey)) {
        const options = filter.valueList ? filter.valueList.map(item => ({
          value: item.key || '',
          displayValue: item.value || '',
          valueDescription: item.description || ''
        })) : [];
        this.filterOptionsCache.set(cacheKey, options);
      }
    });
  }

  onFilterChange(filter: CardFilter, index: number, selectedValue: any) {
    if (index === 0) {
      this.firstFilterValue = selectedValue.value;
      this.filterCardProperties(selectedValue.valueDescription, filter.configs.fixedKey, selectedValue);
      this.getAvailablePropertyConfigs();
    }
  }

  onCardSelectionChange(selectedValue: any) {
    this.layoutService.showLoading = true;
    this.propertyOptions = [];
    this.propertyCtrl.setValue('');
    this.columnNameCtrl.setValue('');
    if (!selectedValue?.value) {
      this.cardName = '';
      this.layoutService.showLoading = false;
      this.cardProperties = this.defaultCardProperties;
      this.cardFilters = [];
      this.removeFilterControls();
      this.getAvailablePropertyConfigs();
    } else {
      this.cardName = selectedValue.displayValue;
      this.removeFilterControls();
      this.store.dispatch(getCardConfigurationAction({ request: { cardId: selectedValue.value, componentId: selectedValue.extraData, type: this.generateReportForCtrl.value } }));
    }
  }

  onGenerateReportForChange(selectedValue: any) {
    this.selectedRowFilterOptions = [];
    this.filterDropdownCtrl.setValue('');
    this.selectedGenerateReportType = selectedValue.value;

    this.store.dispatch(getDefaultFilterAction({ request: { type: selectedValue.value } }));
    this.resetPropertyAndFilter();
  }

  resetPropertyAndFilter() {
    if (!this.isResetGeneralForm) {
      this.removedOrderColumns = [...this.lstStoredEntityColumns];
      this.lstRemovedFilters = [...this.storedCardFilters];
    }
    this.cardSelectionCtrl.setValue('');
    this.isResetGeneralForm = true;
    this.cardFilters = [];
    this.selectedCardFilters = [];
    this.selectedFilters = [];
    this.propertyOptions = [];
    this.propertyCtrl.setValue('');
    this.columnNameCtrl.setValue('');
    this.cardName = '';
    this.sortPropertySectionDataTable = [];
    this.sortRowSectionDataTable = [];
    this.cardProperties = this.defaultCardProperties;
    this.removeFilterControls();
    this.store.dispatch(getDefaultTemplateAction({ request: { type: this.selectedGenerateReportType } }));
    this.getAvailablePropertyConfigs();
  }

  trackByFilterId(index: number, filter: CardFilter): string {
    return `${filter.cardId}_${filter.propertyId}_${index}`;
  }

  onPropertyChange(selectedValue: any) {
    const selectedConfig: any = this.cardProperties.find((property) => {
      return property.propertyId === selectedValue.value
        && `${property.cardId}_${property.componentId}` === selectedValue.extraData;
    })

    const options: any[] = selectedConfig?.options;

    this.propertyOptions = (options || []).reduce(
      (result: any, currentValue: any) => {
        const selectedOptions = this.sortPropertySectionDataTable.reduce(
          (selectedOptionResult, currentItem) => {
            this.sortPropertySectionDataTable.forEach((property) => {
              if (
                (property.entityPropertyId === selectedConfig.id || property.entityPropertyId === selectedConfig.propertyId) && selectedConfig.cardId === property.cardId
                 && selectedConfig.referenceLinkedId === property.entityReferenceLinkedId && selectedConfig.referencePropertyId === property.entityReferencePropertyId
                 && this.firstFilterValue === property.subColumnName
              ) {
                selectedOptionResult.push(
                  ...property.option.split(VERTICAL_LINE_SEPARATOR)
                );
              }
            });
            return selectedOptionResult;
          },
          [] as any[]
        );

        const selectedItem: any = {
          value: currentValue.key,
          label: currentValue.value,
        };
        const checked = !!selectedOptions.find(
          (selectedOption: any) => selectedOption === currentValue.key
        );
        if (options?.length > 1 && checked) {
          return result;
        }
        result.push(selectedItem);
        return result;
      },
      [] as any[]
    );

    const firstUncheckedItem = (this.propertyOptions as any[]).find(
      (propertyOption: any) => !propertyOption.checked && !propertyOption.disabled
    );

    if (firstUncheckedItem) {
      firstUncheckedItem.checked = true;
    }
    let firstFilterOption = this.getFirstFilterOption();

    const formValue = {
      cardId: selectedConfig?.cardId,
      entityComponentId: selectedConfig?.componentId,
      columnName: firstFilterOption ? `${firstFilterOption?.displayValue} - ${selectedConfig?.propertyName}` : selectedConfig?.propertyName,
      subColumnName: this.firstFilterValue,
      systemColumnName: firstFilterOption ? `${firstFilterOption?.displayValue} - ${selectedConfig?.propertyName}` : selectedConfig?.propertyName,
      propertyName: selectedConfig?.propertyName,
      type: selectedConfig?.type,
      propertyNameEntityRef: firstFilterOption?.displayValue,
      propertyId: selectedConfig?.propertyId,
      entityReferencePropertyId: selectedConfig?.referencePropertyId,
      entityReferenceLinkedId: selectedConfig?.referenceLinkedId,
      option: firstUncheckedItem?.value || '',
      cardName: this.cardName
    }

    this.dynamicFormGroup.patchValue(formValue);
  }

  addColumn() {
    this.dynamicFormGroup.markAllAsTouched();
    if (this.dynamicFormGroup.invalid) return;

    this.mapFilterControls();
    const formValue = this.dynamicFormGroup.value;

    // Check for duplicate column name
    const isDuplicateColumn = this.sortPropertySectionDataTable.some(item =>
      item.columnName?.toLowerCase().trim() === formValue.columnName?.toLowerCase().trim()
    );

    if (isDuplicateColumn) {
      const error = { existed: 'Column Name already exists.' };
      this.columnNameCtrl.setErrors({
        ...this.columnNameCtrl.errors,
        ...error
      });
      return;
    }

    const addedIndex = this.availablePropertyOptions.findIndex(opt => opt.value === formValue.propertyId);
    const optionName = this.getOptionName(formValue.option);
    const newRecord: Omit<EntityPropertyDisplayConfiguration, "id"> = {
      columnName: formValue.columnName,
      systemColumnName: formValue.systemColumnName,
      subColumnName: formValue.subColumnName,
      columnNameDescription: this.createPropertyDisplayDescription(formValue, optionName),
      propertyName: this.availablePropertyOptions[addedIndex]?.displayValue,
      order: this.sortPropertySectionDataTable.length + 1,
      entityPropertyId: formValue.propertyId,
      type: formValue.type,
      optionName: this.availablePropertyOptions[addedIndex]?.displayValue,
      isUsed: !this.sortRowSection,
      columnNameMaxLength: this.columnNameMaxLength,
      entityReferencePropertyId: formValue.entityReferencePropertyId,
      entityReferenceLinkedId: formValue.entityReferenceLinkedId,
      cardId: this.cardSelectionCtrl.value,
      cardName: formValue.cardName,
      componentId: formValue.entityComponentId,
      option: formValue.option,
      propertyNameEntityRef: formValue.propertyNameEntityRef,
      disableDelete: false
    }
    this.sortPropertySectionDataTable = [
      ...this.sortPropertySectionDataTable,
      this.createInlineEditFormControls(newRecord)
    ];

    this.getAvailablePropertyConfigs();
    this.columnNameCtrl.reset('');
    this.propertyCtrl.reset('');
    this.propertyOptions = [];

    for (let i=0; i< this.cardFilters.length;i++) {
      if(i != 0 || this.cardFilters[i].configs === this.componentType.datepicker) {
          this.getFilterControl(this.cardFilters[i]).reset();
      }
    }
    
    this.canSubmit = true;
    this.isCompareColumn = true;

  }


  compareWithFunction(o1: any, o2: any[]) {
    return o2.includes(o1);
  }

  private getFirstFilterOption() {
    let firstFilterOption = null;
    if (this.cardFilters.length > 0) {
      const firstFilterValue = this.getFilterControl(this.cardFilters[0]).value;
      const firstFilterOptions = this.getCachedFilterOptions(this.cardFilters[0]);
      firstFilterOption = firstFilterOptions.find(option => option.value === firstFilterValue);
    }
    return firstFilterOption;
  }

  private mapFilterControls() {
    const selectedFilters: CardFilter[] = [];
    const { v4: uuidv4 } = require('uuid');
    let groupId = uuidv4();

    const groupedSelectedFilters = new Map<string, CardFilter[]>();
    this.selectedFilters.forEach(filter => {
      const gId = filter.groupId || '';
      if (!groupedSelectedFilters.has(gId)) {
        groupedSelectedFilters.set(gId, []);
      }
      groupedSelectedFilters.get(gId)!.push(filter);
    });

    const allFiltersExist = this.selectedCardFilters.every(filter => {
      const filterControl = this.getFilterControl(filter);
      if (!filterControl || !filterControl.value) return true;

      return Array.from(groupedSelectedFilters.values()).some(groupFilters =>
        groupFilters.some(existing =>
          existing.cardId === filter.cardId &&
          existing.propertyId === filter.propertyId &&
          existing.value === filterControl.value
        )
      );
    });

    if (allFiltersExist && this.selectedCardFilters.length > 0) {
      return;
    }

    for (let filter of this.selectedCardFilters) {
      const filterControl = this.getFilterControl(filter);
      if (!filterControl || !filterControl.value) continue;

      if (filter.configs.componentType === this.componentType.dropdown) {
        const filterOptions = this.getFilterOptions(filter);
        let filterOption = filterOptions.find(option => option.value === filterControl.value);
        selectedFilters.push({
          ...filter,
          groupId: groupId,
          value: filterControl.value,
          displayValue: filterOption?.displayValue || '',
        })
      }
      if (filter.configs.componentType === this.componentType.datepicker) {
        const datepipe = new DatePipe('en-US');
        const dateStr = datepipe.transform(filterControl.value, 'yyyy-MM-dd');
        selectedFilters.push({
          ...filter,
          groupId: groupId,
          value: dateStr ?? '',
          displayValue: dateStr ?? '',
        });
      }
    }
    this.selectedFilters = this.selectedFilters.concat(selectedFilters);
  }

  private resetAddPropertyForm() {
    this.removeFilterControls();
    this.dynamicFormGroup.reset();
    this.cardProperties = this.defaultCardProperties;
    this.getAvailablePropertyConfigs();
    this.propertyOptions = [];
    this.cardFilters = [];
  }

  getAvailablePropertyConfigs() {
    this.availablePropertyOptions = (this.cardProperties as any).reduce(
      (result: Option[] | any, propertyConfig: any) => {
        const propertyConfigId = propertyConfig.propertyId || propertyConfig.id;
        const listSelectedProperty = this.sortPropertySectionDataTable.filter(item => item.entityPropertyId === propertyConfigId && propertyConfig.cardId === item.cardId
           && propertyConfig.referenceLinkedId === item.entityReferenceLinkedId && propertyConfig.referencePropertyId === item.entityReferencePropertyId && item.subColumnName === this.firstFilterValue);
        let isExistedProperty = !!listSelectedProperty?.length;
        let propertyOptions = propertyConfig?.options;
        if (listSelectedProperty?.length && propertyOptions?.length) {
          isExistedProperty = propertyOptions.length === listSelectedProperty.length;
        }
        if (isExistedProperty) {
          return result;
        }
        let valueDescription = !propertyConfig?.referencePropertyId
          ? (propertyConfig?.configs?.description ? propertyConfig?.configs?.description : '')
          : (`${propertyConfig?.referencePropertyName + (propertyConfig?.configs?.description ? ' /' + propertyConfig?.configs?.description : '')}`)
        let displayValue = `${propertyConfig.propertyName}`;

        result.push({
          value: propertyConfig?.propertyId,
          displayValue: displayValue,
          valueDescription: valueDescription,
          type: propertyConfig?.type,
          options: propertyConfig?.options,
          option: propertyConfig.option,
          extraData: `${propertyConfig.cardId}_${propertyConfig.componentId}`
        });
        return result;
      },
      [] as Option[]
    ).sort((a: any, b: any) => a.displayValue.localeCompare(b.displayValue));
  }

  onRowActions(
    event: { row: EntityPropertyDisplayConfiguration; type: string }
  ) {
    this.canSubmit = true;
    this.isCompareColumn = true;
    switch (event.type) {
      case this.ACTION.ADD_SORT_ROW: {
        event.row.isUsed = true;
        this.addSortRow(event.row);
        const index = this.sortPropertySectionDataTable.findIndex(
          (item) =>
            item.cardId === event.row.cardId &&
            item.entityPropertyId === event.row.entityPropertyId &&
            item.subColumnName === event.row.subColumnName &&
            (!item.option || item.option === event.row.option)
        );
        if (index > -1) {
          this.sortPropertySectionDataTable[index].isUsed = true;
          this.sortPropertySectionDataTable = [...this.sortPropertySectionDataTable];
        }
        break;
      }
      case this.ACTION.SORT_CHANGE: {
        this.changeSortType(event.row);
        break;
      }
      case this.ACTION.EDIT_COLUMN_NAME: {
        const index = this.sortPropertySectionDataTable.findIndex(
          (item) =>
            item.cardId === event.row.cardId &&
            item.entityPropertyId === event.row.entityPropertyId &&
            item.subColumnName === event.row.subColumnName &&
            (!item.option || item.option === event.row.option)
        );
        if (index > -1) {
          this.sortPropertySectionDataTable[index].editing = !this.sortPropertySectionDataTable[index].editing;
          this.sortPropertySectionDataTable = [...this.sortPropertySectionDataTable];
        }
        this.canSubmit = true;
        this.isCompareColumn = true;
        break;
      }
      case this.ACTION.REMOVE_PROPERTY_ROW: {
        this.sortPropertySectionDataTable = this.sortPropertySectionDataTable.filter(
          (item) =>
            !(item.entityPropertyId === event.row.entityPropertyId && item.cardId === event.row.cardId &&
              item.subColumnName === event.row.subColumnName && (!item.option || item.option === event.row.option))
        );

        let lstRemovedFilters: CardFilter[] = [];
        const isLastCard = this.sortPropertySectionDataTable.findIndex(item => item.cardId === event.row.cardId) === -1;
        const isLastFilter = this.sortPropertySectionDataTable.findIndex(item => item.subColumnName === event.row.subColumnName) === -1;

        if (isLastCard) {
          this.selectedCardFilters = this.selectedCardFilters.filter(filter => filter.cardId !== event.row.cardId);
          lstRemovedFilters = this.storedCardFilters.filter(filter => filter.cardId === event.row.cardId);
          this.selectedFilters = this.selectedFilters.filter(filter => filter.cardId !== event.row.cardId);
        } else if (isLastFilter) {
          const removedFilterGroups = this.selectedFilters.filter(filter => filter.value === event.row.subColumnName).map(x => x.groupId);
          lstRemovedFilters = this.storedCardFilters.filter(filter => filter.value === event.row.subColumnName || removedFilterGroups.includes(filter.groupId));
          this.selectedFilters = this.selectedFilters.filter(filter => filter.value !== event.row.subColumnName && !removedFilterGroups.includes(filter.groupId));
        }
        this.lstRemovedFilters = [...this.lstRemovedFilters, ...lstRemovedFilters];

        this.sortRowSectionDataTable = this.sortRowSectionDataTable.filter(
          (item) =>
            !(item.entityPropertyId === event.row.entityPropertyId && item.cardId === event.row.cardId &&
              item.subColumnName === event.row.subColumnName && (!item.option || item.option === event.row.option))
        );
        const orderIndex = this.storedProperties.findIndex(item => item.propertyId === event.row.entityPropertyId && item.cardId === event.row.cardId && (!item.option || item.option === event.row.option));
        if (orderIndex > -1) {
          this.removedOrderColumns.push(event.row);
        }
        this.getAvailablePropertyConfigs();
        break;
      }
      case this.ACTION.REMOVE_SORT_ROW: {
        this.sortRowSectionDataTable = this.sortRowSectionDataTable.filter(
          (item) =>
            !(item.entityPropertyId === event.row.entityPropertyId && item.cardId === event.row.cardId &&
              item.subColumnName === event.row.subColumnName && (!item.option || item.option === event.row.option))
        );
        const index = this.sortPropertySectionDataTable.findIndex(
          (item) =>
            item.cardId === event.row.cardId &&
            item.entityPropertyId === event.row.entityPropertyId &&
            item.subColumnName === event.row.subColumnName &&
            (!item.option || item.option === event.row.option)
        );
        if (index > -1) {
          this.sortPropertySectionDataTable[index].isUsed = false;
          this.sortPropertySectionDataTable = [...this.sortPropertySectionDataTable];
        }

        this.removedOrderRows.push(event.row);
        this.getAvailablePropertyConfigs();
        break;
      }
    }
  }

  changeItem(event: ReorderInfo, isSortColumn = false) {
    this.canSubmit = true;
    this.isCompareColumn = true;
    if (isSortColumn) {
      this.sortPropertySectionDataTable = this.gridview.dataSource;
      return;
    }
    this.sortRowSectionDataTable = this.gridviewRow.dataSource;
  }

  onGenerateReport() {
    this.templateNameCtrl.removeValidators(Validators.required);
    this.templateNameCtrl.updateValueAndValidity();
    this.fixedFormGroup.markAllAsTouched();
    if (this.fixedFormGroup.valid) {
      let filters: CardFilter[] = [];
      let properties: ReportTemplateColumn[] = [];
      if (this.cardFilter) {
        for (const value of this.filterDropdownCtrl.value) {
          const id = this.oldFilterData.find(item => item.value === value)?.id;
          const displayValue = this.filterDropdownOptions.find(item => item.value === value)?.displayValue;
          filters.push({
            ...this.cardFilter,
            id: id ?? GUID_EMPTY,
            configs: this.cardFilter.configs,
            value: value,
            displayValue: displayValue ?? ''
          })
        }
      }

      filters = filters.concat([...this.selectedFilters])

      properties = this.sortPropertySectionDataTable.map((item: any, index: number) => {
        return {
          id: item.id,
          propertyName: item.propertyName,
          propertyId: item.entityPropertyId,
          cardId: item.cardId,
          referencePropertyId: item.entityReferencePropertyId,
          referenceLinkedId: item.entityReferenceLinkedId,
          referencePropertyName: item.propertyNameEntityRef,
          componentId: item.componentId,
          columnName: item.form?.value?.columnName,
          systemColumnName: item.systemColumnName,
          subColumnName: item.subColumnName,
          type: item.type,
          orderColumn: index + 1,
          option: item.option,
        }
      })

      this.sortRowSectionDataTable = this.sortRowSectionDataTable.map((item: any, index: number) => {
        return {
          ...item,
          order: index + 1
        }
      });


      properties = properties.map(property => {
        const sortRowRecord = this.sortRowSectionDataTable.find(sortRow =>
          sortRow.entityPropertyId === property.propertyId &&
          sortRow.cardId === property.cardId &&
          sortRow.subColumnName === property.subColumnName &&
          (!sortRow.option || sortRow.option === property.option)
        );
        if (sortRowRecord) {
          return {
            ...property,
            orderRow: sortRowRecord.order,
            sortType: sortRowRecord.sortType,
          };
        }

        return property;
      });

      const fileName = `${this.reportNameCtrl.value}`;

      let request = {
        fileName: fileName,
        type: this.generateReportForCtrl.value,
        filters: filters,
        properties: properties,
        timeZoneOffset: new Date().getTimezoneOffset()
      }

      this.layoutService.showLoading = true;
      this._generateReportSelector();
      this.store.dispatch(generateAdhocReportAction({ request }));
    }
  }

  onSaveTemplate(saveNewTemplate: boolean) {
    this.templateNameCtrl.addValidators(Validators.required);
    this.templateNameCtrl.updateValueAndValidity();
    this.fixedFormGroup.markAllAsTouched();
    if (this.fixedFormGroup.valid) {
      let filters: CardFilter[] = [];
      let properties: ReportTemplateColumn[] = [];
      if (this.cardFilter) {
        for (const value of this.filterDropdownCtrl.value) {
          const id = !saveNewTemplate ? this.oldFilterData.find(item => item.value === value)?.id : GUID_EMPTY;
          const displayValue = this.filterDropdownOptions.find(item => item.value === value)?.displayValue;
          filters.push({
            ...this.cardFilter,
            id: id ?? GUID_EMPTY,
            configs: this.cardFilter.configs,
            value: value,
            displayValue: displayValue ?? ''
          })
        }
      }

      this.selectedFilters = this.selectedFilters.map((item, index) => ({...item, configs: {...item.configs, order: index}}));
      
      if(!saveNewTemplate) {
        const removeRowFilters = this.lstRemovedFilters.map(item => ({
          ...item,
          isDeleted: true
        }))

        filters = filters.concat([...this.selectedFilters, ...removeRowFilters]);
      } else {
        filters = filters.concat([...this.selectedFilters])
      }

      properties = this.sortPropertySectionDataTable.map((item: any, index: number) => {
        return {
          id: item.id,
          propertyName: item.propertyName,
          propertyId: item.entityPropertyId,
          cardId: item.cardId,
          referencePropertyId: item.entityReferencePropertyId,
          referenceLinkedId: item.entityReferenceLinkedId,
          referencePropertyName: item.propertyNameEntityRef,
          componentId: item.componentId,
          columnName: item.form?.value?.columnName,
          systemColumnName: item.systemColumnName,
          subColumnName: item.subColumnName,
          type: item.type,
          orderColumn: index + 1,
          option: item.option,
          disableDelete: item.disableDelete
        }
      })

      this.sortRowSectionDataTable = this.sortRowSectionDataTable.map((item: any, index: number) => {
        return {
          ...item,
          order: index + 1
        }
      });


      properties = properties.map(property => {
        const sortRowRecord = this.sortRowSectionDataTable.find(sortRow =>
          sortRow.entityPropertyId === property.propertyId &&
          sortRow.cardId === property.cardId &&
          sortRow.subColumnName === property.subColumnName &&
          (!sortRow.option || sortRow.option === property.option)
        );
        if (sortRowRecord) {
          return {
            ...property,
            orderRow: sortRowRecord.order,
            sortType: sortRowRecord.sortType,
          };
        }

        return property;
      });
      if(!saveNewTemplate) {
          var lstRemovedProperties = this.storedProperties.
                  filter(item => this.removedOrderColumns.find(x => x.entityPropertyId === item.propertyId && x.cardId === item.cardId
                    && x.subColumnName === item.subColumnName
                    && (!x.option || x.option === item.option)));

          const removedProperties = lstRemovedProperties.map(item => ({
            ...item,
            orderColumn: -1
          }));

          properties = properties.concat(removedProperties);
      }

      let request = {
        templateName: this.templateNameCtrl.value,
        reportName: this.reportNameCtrl.value,
        type: this.generateReportForCtrl.value,
        filters: filters,
        properties: properties,
        timeZoneOffset: new Date().getTimezoneOffset()
      }

      if (!saveNewTemplate) {
        this.layoutService.showLoading = true;
        this._updateReportTemplateSelector();
        this.store.dispatch(updateReportTemplateAction({
          request: {
            ...request,
            templateId: this.templateId!
          }
        }))
      } else {

        this.store.dispatch(getTemplatesAction());
        this.store
          .select(getTemplatesSelector)
          .pipe(
            filter(res => !!res && !res.isLoading),
            take(1)
          )
          .subscribe(response => {
            const templates = response?.payload?.templates ?? [];
            const nameExists = templates.some(template =>
              template.name?.toLowerCase() === request.templateName.toLowerCase()
            );
            if (nameExists) {
              const error = { templateNameExists: `${this.templateNamePlaceHolder} already exists.` };
              this.templateNameCtrl.setErrors({
                ...this.templateNameCtrl.errors,
                ...error
              });
              this.layoutService.showLoading = false;
              return;
            }
            
              this.layoutService.showLoading = true;
              this._createReportTemplateSelector();
              this.store.dispatch(createReportTemplateAction({ request }));
            });
      }
    }
  }

  onChangeChipSelection(dataChanges: any[]) {
    this.lstFilterDescription = dataChanges?.length
      ? this.filterDropdownOptions.reduce((descriptions: string[], item) => {
        if (dataChanges.includes(item.value) && item.valueDescription) {
          descriptions.push(item.valueDescription);
        }
        return descriptions;
      }, [])
      : [];
    if (!this.isResetGeneralForm) {
      this.lstRemovedFilters = this.storedCardFilters.filter((filter) => !dataChanges.includes(filter.value) && filter.type === ReportFilterType.row);
    }
    this.filterCardProperties();
    this.getAvailablePropertyConfigs();
  }

  onRemoveFilter(event: { chipData: ChipData, isLastCard: boolean }) {
    const removedCardFilters = this.selectedFilters.filter(filter => filter.groupId === event.chipData.groupId);
    this.selectedCardFilters = this.selectedCardFilters.filter(filter => filter.groupId !== event.chipData.groupId);
    this.selectedFilters = this.selectedFilters.filter(filter => filter.groupId !== event.chipData.groupId);
    const firstFilter = removedCardFilters.reduce<CardFilter | null>((min, filter) => {
        const order = filter.configs?.order;
        if (order === undefined) return min;
        if (!min) return filter;
        return (order < (min.configs?.order ?? Infinity)) ? filter : min;
      }, null) ?? removedCardFilters[0];
    const isLastFilter = !(this.selectedFilters.some(filter => filter.value === firstFilter?.value));
    let removedProperties: EntityPropertyDisplayConfiguration[] = [];
    if (event.isLastCard) {
      removedProperties = this.lstStoredEntityColumns.filter(item => item.cardId === event.chipData.cardId);
      this.sortPropertySectionDataTable = this.sortPropertySectionDataTable.filter(item => item.cardId !== event.chipData.cardId);
      this.sortRowSectionDataTable = this.sortRowSectionDataTable.filter(item => item.cardId !== event.chipData.cardId);
    } else if(isLastFilter) {
      removedProperties = this.lstStoredEntityColumns.filter(item => item.subColumnName === firstFilter?.value);
      this.sortPropertySectionDataTable = this.sortPropertySectionDataTable.filter(item => item.subColumnName !== firstFilter?.value);
      this.sortRowSectionDataTable = this.sortRowSectionDataTable.filter(item => item.subColumnName !== firstFilter?.value);
    }
    this.lstRemovedFilters = this.storedCardFilters.filter(filter => filter.groupId === event.chipData.groupId);
    this.removedOrderColumns = [...this.removedOrderColumns, ...removedProperties];
    this.getAvailablePropertyConfigs();
  }

  onCancel() {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      panelClass: 'confirm-popup',
      autoFocus: false,
      data: {
        title: 'Cancel Action',
        text: 'Are you sure want to cancel any/all changes?',
        type: ConfirmType.Cancel,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.router.navigate(['/member/adhoc-report']);
      }
    });
  }

  private createInlineEditFormControls(
    obj: EntityPropertyDisplayConfiguration
  ): EntityPropertyDisplayConfiguration {
    const result = {
      ...obj,
      form: this.fb.group({
        columnName: new FormControl(
          obj.columnName,
          getValidatorsFromColumns(
            this.orderColumns[0].name,
            this.orderColumns,
            obj
          )
        ),
      }),
    };
    return result;
  }

  private _generateReportSelector() {
    this.store
      .pipe(select(generateAdhocReportSelector),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((res) => {
        if (res?.state === STATE.SUCCESS) {
          this.layoutService.showLoading = false;
          this.router.navigateByUrl(`/member/adhoc-report`);
          this.store.dispatch(clearGenerateAdhocReportStateAction());
        }
        if (res?.state === STATE.FAIL) {
          this.layoutService.showLoading = false;
          showBanner.call(this, BannerType.Fail, '', '', {customMessage: this.errorWhileSaving });
          this.store.dispatch(clearGenerateAdhocReportStateAction());
        }
      });
  }

  private _createReportTemplateSelector() {
    this.store
      .pipe(select(createReportTemplateSelector),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((res) => {
        if (res?.state === STATE.SUCCESS) {
          this.layoutService.showLoading = false;
          this.router.navigateByUrl(`/member/adhoc-report`);
        }
        if (res?.state === STATE.FAIL) {
          this.layoutService.showLoading = false;
          showBanner.call(this, BannerType.Fail, '', '', {customMessage: this.errorWhileSaving });
          this.store.dispatch(clearCreateReportTemplateStateAction());
        }
      });
  }

  private _updateReportTemplateSelector() {
    this.store
      .pipe(select(updateReportTemplateSelector),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((res) => {
        if (res?.state === STATE.SUCCESS) {
          this.layoutService.showLoading = false;
          this.router.navigateByUrl(`/member/adhoc-report`);
        }
        if (res?.state === STATE.FAIL) {
          this.layoutService.showLoading = false;
          showBanner.call(this, BannerType.Fail, '', '', {customMessage: this.errorWhileSaving });
          this.store.dispatch(clearUpdateReportTemplateStateAction());
        }
      });
  }

  private checkExits(obj: EntityPropertyDisplayConfiguration): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const allRows = [...this.sortPropertySectionDataTable];
      const existed = allRows.some(
        (item) =>
          !(
            item.entityPropertyId === obj.entityPropertyId &&
            (!item.option || item.option === obj.option)
          ) &&
          item.form?.value?.columnName?.toLowerCase()?.trim() ===
          control.value.toLowerCase().trim()
      );
      return existed ? { existed: true } : null;
    };
  }

  private createPropertyDisplayDescription(formValue: any, optionName: string) {
    let subText = !formValue?.entityReferencePropertyId
      ? (formValue?.propertyName ? (formValue?.propertyName + (formValue?.propertyItem ? ' / ' + formValue?.propertyItem : '')) : '')
      : (`${formValue?.propertyNameEntityRef + (formValue?.propertyName ? ' / ' + formValue?.propertyName : '') + (formValue?.propertyItem ? ' / ' + formValue?.propertyItem : '')}`);
    let cardName = formValue.cardName ? `${formValue.cardName} / ` : '';
    let option = formValue.option ? ` / ${optionName}` : '';
    subText = subText ? (cardName + subText + option) : '';
    return subText;
  }

  private getOptionName(options: string) {
    return (this.propertyOptions as any).find(
      (item: RadioOption) => item.value === options
    )?.label;
  }

  private addSortRow(config: EntityPropertyDisplayConfiguration) {
    if (
      this.sortRowSectionDataTable.find(
        (item) =>
          item.cardId === config.cardId &&
          item.componentId === config.componentId &&
          item.entityPropertyId === config.entityPropertyId &&
          item.subColumnName === config.subColumnName &&
          (!item.option || item.option === config.option)
      )
    ) {
      return;
    }
    this.canSubmit = true;
    this.isCompareColumn = true;
    this.sortRowSectionDataTable = [
      ...this.sortRowSectionDataTable,
      {
        ...this.getPropertyDisplayConfig(config),
        columnNameDescription: config.columnNameDescription,
        order: this.sortRowSectionDataTable?.length + 1,
        sortType: this.sortable ? SORT_TYPE.ASC : undefined,
      },
    ];
  }

  private getPropertyDisplayConfig(config: (EntityPropertyDisplayConfiguration & { propertyId?: string })) {
    const cardName = this.cardSelectionOptions.find(x => x.value === config.cardId)?.displayValue || '';
    const property = this.storedProperties.find(property => property.propertyId === config.propertyId && property.subColumnName === config.subColumnName && property.referencePropertyId === config.entityReferencePropertyId && property.referenceLinkedId === config.entityReferenceLinkedId && property.option === config.option &&property.cardId === config.cardId ) as any;
    let listOption = property?.options;
    const configs = {
      ...config,
      entityPropertyId: config.propertyId ?? config.entityPropertyId,
      cardName: cardName,
      type: property?.type,
      propertyNameEntityRef: property?.referencePropertyName,
      optionName: listOption ? listOption[config.option as any] : '',
    };

    return {
      columnName: configs.columnName,
      subColumnName: configs.subColumnName,
      columnNameDescription: this.createPropertyDisplayDescription(
        configs,
        configs.option as string
      ),
      id: configs.id,
      componentId: configs.componentId,
      cardId: configs.cardId,
      entityPropertyId: configs.entityPropertyId,
      propertyName: configs.propertyName,
      option: configs.option,
      entityReferencePropertyId: configs.entityReferencePropertyId,
      entityReferenceLinkedId: configs.entityReferenceLinkedId,
      propertyNameEntityRef: configs.propertyNameEntityRef,
      description: configs.description
    };
  }

  private changeSortType(row: EntityPropertyDisplayConfiguration) {
    const index = this.sortRowSectionDataTable.findIndex(
      (item) =>
        item.entityPropertyId === row.entityPropertyId &&
        (!item.option || item.option === row.option)
    );
    if (index < 0) {
      return;
    }
    this.sortRowSectionDataTable[index].sortType =
      this.sortRowSectionDataTable[index].sortType === SORT_TYPE.ASC
        ? SORT_TYPE.DESC
        : SORT_TYPE.ASC;
    this.sortRowSectionDataTable = [...this.sortRowSectionDataTable];
  }

  private filterCardProperties(filterDescription?: any, fixedKey?: string, selectedValue?: any) {
    const checkForRelationShip = fixedKey === FixedPropertyKey.RelationShip && !!filterDescription;
    if(checkForRelationShip && this.personRelationShipTypes.includes(Number(filterDescription))) {
      this.cardProperties = this.cardPropertiesWithoutFilter.filter(item => item.referenceLinkedId === ENTITY_PERSON_GUID || item.referenceLinkedId === ENTITY_PARTICIPANT_GUID);
    } else if(checkForRelationShip && RelationshipOptions.Organization === Number(filterDescription)) {
      this.cardProperties = this.cardPropertiesWithoutFilter.filter(item => item.referenceLinkedId === ENTITY_ORGANIZATION_GUID);
    } else if(fixedKey === AgentPropertyKey && selectedValue?.value) {
      this.cardProperties = this.cardPropertiesWithoutFilter.filter(item => item.referenceLinkedId === selectedValue.value);
    } else {
      const activeFilters = filterDescription ? [filterDescription] : this.lstFilterDescription;
      this.cardProperties = this.cardPropertiesWithoutFilter.filter(item =>
        !item.filterBy ||
        item.filterBy.some(filterValue => activeFilters.includes(filterValue))
      );
    }
  }

  private removeFilterControls(): void {
    Object.keys(this.dynamicFormGroup.controls)
      .filter(controlName => controlName.startsWith('filter_'))
      .forEach(controlName => this.dynamicFormGroup.removeControl(controlName));
  }

  ngOnDestroy() {
    this.store.dispatch(clearTemplateStateAction());
    this.store.dispatch(clearCardConfigurationStateAction());
    this.store.dispatch(clearDefaultFilterStateAction());
    this.store.dispatch(clearDefaultTemplateStateAction());
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public onSaveColumnName(event: ColumnSetPropertyDisplayConfiguration & Row) {
      const editingColumnIndex = this.gridview.dataSource.findIndex((section: any) => {
          return section.entityPropertyId === event.entityPropertyId && section.cardId === event.cardId
          && section.entityReferencePropertyId === event.entityReferencePropertyId && section.option === event.option && section.subColumnName === event.subColumnName
      })

      if (editingColumnIndex !== -1) {
        const formValue = (this.gridview.dataSource[editingColumnIndex] as any)?.form?.value;

        if (formValue && 'columnName' in formValue) {
        var t = this.sortPropertySectionDataTable[editingColumnIndex];
          this.sortPropertySectionDataTable[editingColumnIndex].columnName = formValue.columnName;
          this.sortPropertySectionDataTable = [...this.sortPropertySectionDataTable];

          const editingRowIndex = this.gridviewRow.dataSource.findIndex((section: any) => {
          return section.entityPropertyId === event.entityPropertyId && section.cardId === event.cardId
           && section.entityReferencePropertyId === event.entityReferencePropertyId && section.option === event.option && section.subColumnName === event.subColumnName
          })
          if(editingRowIndex !== -1) {
            this.sortRowSectionDataTable[editingRowIndex].columnName = formValue.columnName;
            this.sortRowSectionDataTable = [...this.sortRowSectionDataTable]
          }
        }
      }
  }
}  